(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7505],{

/***/ 79477:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[[...page]]",
      function () {
        return __webpack_require__(32972);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _page_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 206 modules
var AemGrid = __webpack_require__(94020);
// EXTERNAL MODULE: ./components/core/Head/NextHead.jsx
var NextHead = __webpack_require__(20812);
// EXTERNAL MODULE: ./components/Default/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(3282);
// EXTERNAL MODULE: ./components/ContactUs/v1/ContactUs.jsx + 11 modules
var ContactUs = __webpack_require__(71735);
// EXTERNAL MODULE: ./components/KeySpecifier/v1/KeySpecifier.jsx + 3 modules
var KeySpecifier = __webpack_require__(26216);
// EXTERNAL MODULE: ./components/AssociateMembership/v1/AssociateMembership.jsx + 5 modules
var AssociateMembership = __webpack_require__(65696);
// EXTERNAL MODULE: ./components/Literature/v1/Literature/index.jsx + 7 modules
var Literature = __webpack_require__(78774);
// EXTERNAL MODULE: ./components/TechnicalSpecs/v1/TechnicalSpecs.jsx + 7 modules
var TechnicalSpecs = __webpack_require__(18478);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx + 1 modules
var ProductAccordion = __webpack_require__(30534);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 112 modules
var GlobalPageHeader = __webpack_require__(92058);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./components/KnowledgeArticle/v1/KnowledgeArticle.jsx + 2 modules
var KnowledgeArticle = __webpack_require__(83224);
// EXTERNAL MODULE: ./components/KnowledgeArticle/v1/KnowledgeArticleFiller.jsx
var KnowledgeArticleFiller = __webpack_require__(787);
// EXTERNAL MODULE: ./components/BrowseAllStores/v1/BrowseAllStores.jsx + 4 modules
var BrowseAllStores = __webpack_require__(35188);
// EXTERNAL MODULE: ./components/FriendsAndFamily/v1/FriendsAndFamily.jsx + 4 modules
var FriendsAndFamily = __webpack_require__(10057);
// EXTERNAL MODULE: ./components/InstallDesignServices/v1/InstallDesignServices.jsx + 4 modules
var InstallDesignServices = __webpack_require__(97662);
// EXTERNAL MODULE: ./components/FindStore/v1/FindStore.jsx + 6 modules
var FindStore = __webpack_require__(63337);
;// CONCATENATED MODULE: ./i18n/useProductListi18n.js

const useProductListi18n = (param)=>{
    let { componentProps , total , generalRef  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    var _noResultsMsg;
    const i18n = {
        expanded: t("kf.productTab.aria.expanded"),
        collapsed: t("kf.productTab.aria.collapsed"),
        totalCount: t("kf.plp.label.totalCount", {
            count: total
        }),
        hideFilterAria: t("kf.plp.label.hideFilterAria"),
        showFilterAria: t("kf.plp.label.showFilterAria"),
        clearAllAria: t("kf.plp.label.clearAllAria"),
        listWith: t("kf.plp.label.listWith"),
        items: t("kf.plp.label.items"),
        facetListAriaExpandOrCollapse: t("kf.plp.label.facetListAriaExpandOrCollapse"),
        showMoreFiltersAria: t("kf.plp.label.showMoreFiltersAria"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        sortBykey: t("kf.plp.label.sortBykey"),
        salePriceAria: t("kf.plp.label.salePriceAria"),
        originalPriceAria: t("kf.plp.label.originalPriceAria"),
        productDescription: t("kf.plp.label.productDescription"),
        colorsLinkAria: t("kf.plp.label.colorsLinkAria"),
        pageTitleAria: t("kf.plp.label.pageTitleAria", {
            categoryName: componentProps.categoryKey,
            brandName: generalRef === null || generalRef === void 0 ? void 0 : generalRef.brandName
        }),
        print: t("kf.plp.label.print"),
        share: t("kf.plp.label.share"),
        wishlist: t("kf.plp.label.wishlist"),
        showFilter: t("kf.plp.label.showFilter"),
        hideFilter: t("kf.plp.label.hideFilter"),
        showFilterState: t("kf.plp.label.showFilterState"),
        hideFilterState: t("kf.plp.label.hideFilterState"),
        filters: t("kf.plp.label.filters"),
        filterSort: t("kf.plp.label.filterSort"),
        listviewFilter: t("kf.plp.label.listViewDeclare"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        view: t("kf.plp.label.view"),
        all: t("kf.plp.label.all"),
        gridView: t("kf.plp.label.gridView"),
        columnView: t("kf.plp.label.columnView"),
        sort: t("kf.plp.label.sort"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        applyFilters: "Apply Filters",
        results: t("kf.plp.label.results"),
        annsacksResults: t("kf.plp.label.annsacksResults"),
        loadMore: t("kf.plp.label.loadMore"),
        backToTop: t("kf.plp.label.backToTop"),
        showMore: componentProps.isAnnsacksPlp ? t("annsacks.plp.label.showMore") : t("kf.plp.label.showMore"),
        showLess: componentProps.isAnnsacksPlp ? t("annsacks.plp.label.showLess") : t("kf.plp.label.showLess"),
        clearAll: t("kf.plp.label.clearAll"),
        priceRangeTitle: t("kf.plp.label.priceRangeTitle"),
        priceRangeDesc: t("kf.plp.label.priceRangeDesc"),
        to: t("kf.plp.label.to"),
        minText: t("kf.plp.label.minText"),
        maxText: t("kf.plp.label.maxText"),
        sameCategory: componentProps.sameCategory ? componentProps.sameCategory : t("kf.compare.validation.sameCategory"),
        maxProduct: componentProps.maxProduct ? componentProps.maxProduct : t("kf.compare.validation.maxProducts"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        errors: {
            validRange: t("kf.plp.error.validRange"),
            minGreaterThanMax: t("kf.plp.error.minGreaterThanMax"),
            maxGreaterThanZero: t("kf.plp.error.maxGreaterThanZero"),
            checkValid: t("kf.error.message.price")
        },
        ariaLabel: {
            columnViewSelected: t("kf.productTab.aria.columnViewSelected"),
            columnViewNotSelected: t("kf.productTab.aria.columnViewNotSelected"),
            gridViewSelected: t("kf.productTab.aria.gridViewSelected"),
            gridViewNotSelected: t("kf.productTab.aria.gridViewNotSelected")
        },
        startingAt: t("kf.plp.label.startingAt"),
        viewResults: t("kf.plp.label.viewResults"),
        new: (generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.new) ? generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.new : t("kf.plp.label.new"),
        onSale: (generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.onSale) ? generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.onSale : t("kf.plp.label.onSale"),
        exclusive: (generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.exclusive) ? generalRef === null || generalRef === void 0 ? void 0 : generalRef.badgeText.exclusive : t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        filterOpenAlert: t("kf.plp.ariaLabel.filterOpenAlert"),
        filterCloseAlert: t("kf.plp.ariaLabel.filterCloseAlert"),
        removeItem: t("kf.favorites.removeItem"),
        removeItemError: t("kf.favorites.removeItemError"),
        noResultsMssg: (_noResultsMsg = componentProps.noResultsMsg) !== null && _noResultsMsg !== void 0 ? _noResultsMsg : t("kf.plp.label.noResultsMssg"),
        featured: t("kf.plp.label.featured"),
        // featured: "Featured",
        priceDesc: t("kf.plp.label.priceDesc"),
        priceAsc: t("kf.plp.label.priceAsc"),
        atoz: t("kf.plp.label.atoz"),
        ztoa: t("kf.plp.label.ztoa"),
        // extras
        newToOld: t("kf.myProducts.sort.newToOld"),
        oldToNew: t("kf.myProducts.sort.oldToNew"),
        // needtoCheck check in getSelectedSort helper.js
        AToZ: t("kf.services.sort.AToZ"),
        ZToA: t("kf.services.sort.ZToA"),
        filterTitle: (facetName, facetCount)=>t("kf.plp.ariaLabel.filterTitle", {
                facetName: facetName,
                facetCount: facetCount
            }),
        arialLabelPrint: t("kf.plp.label.aria.print"),
        ariaLabelShare: t("kf.plp.label.aria.share"),
        ariaLabelZeroResults: t("kf.pkp.ariaLabel.zeroResults"),
        ariaLabelFilteredResult: (totalResult)=>t("kf.plp.ariaLabel.filteredResult", {
                totalResult: totalResult
            }),
        ariaLabelFilteredResults: (totalResults)=>t("kf.plp.ariaLabel.filteredResults", {
                totalResults: totalResults
            }),
        ariaLabelAppliedFilter: t("kf.plp.ariaLabel.appliedFilter"),
        ariaLabelAppliedFilters: t("kf.plp.ariaLabel.appliedFilters"),
        ariaLabelBackToTop: t("kf.plp.ariaLabel.backToTop")
    };
    return i18n;
};
/* harmony default export */ var i18n_useProductListi18n = (useProductListi18n);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/ProductList/v2/Sort/index.module.scss
var index_module = __webpack_require__(19806);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/Filter/index.module.scss
var Filter_index_module = __webpack_require__(3899);
var Filter_index_module_default = /*#__PURE__*/__webpack_require__.n(Filter_index_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/StickyNav/stickyNavHeader.jsx + 1 modules
var stickyNavHeader = __webpack_require__(24751);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductListView/productListHelper.js
const keyPress = (e, filterModalRef, cb)=>{
    const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
    const focusContent = filterModalRef.current.querySelectorAll(focusElements);
    const firstElem = focusContent[0];
    const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
    if (e.key === "Escape") {
        cb(false);
    }
    if (e.key === "Tab") {
        if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterModalRef.current)) {
            e.preventDefault();
            lastElem.focus();
        }
        if (!e.shiftKey && document.activeElement === lastElem) {
            e.preventDefault();
            firstElem.focus();
        }
    }
};
const getIsPresentOnDevice = (isHideOnDesktop, isHideOnMobile)=>{
    if (isHideOnMobile === "true" && isHideOnDesktop === "true") {
        return false;
    }
    let showDefaultBehaviour = isHideOnDesktop === undefined && isHideOnMobile === undefined;
    showDefaultBehaviour = showDefaultBehaviour || isHideOnMobile === "false" && isHideOnDesktop === "false";
    if (showDefaultBehaviour) {
        return true;
    }
    const isPresentOnDeskTop = window.matchMedia("(min-width: 1280px)").matches;
    if (isHideOnDesktop === "true") {
        return isPresentOnDeskTop;
    }
    return isHideOnMobile === "true" ? !isPresentOnDeskTop : isPresentOnDeskTop;
};

// EXTERNAL MODULE: ./components/ProductList/v2/Filter/index.jsx + 5 modules
var Filter = __webpack_require__(50772);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/index.module.scss
var ProductListView_index_module = __webpack_require__(29472);
var ProductListView_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductListView_index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.module.scss
var ProductTile_index_module = __webpack_require__(50702);
var ProductTile_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductTile_index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/Pagination/index.jsx
var Pagination = __webpack_require__(70487);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.jsx + 1 modules
var ProductTile = __webpack_require__(59804);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/product.js
var utils_product = __webpack_require__(29843);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/core/Image/DynamicImage.jsx
var DynamicImage = __webpack_require__(18377);
// EXTERNAL MODULE: ./components/PromoBanner/v1/index.module.scss
var v1_index_module = __webpack_require__(41256);
var v1_index_module_default = /*#__PURE__*/__webpack_require__.n(v1_index_module);
// EXTERNAL MODULE: ./components/PromoBanner/v2/promoBannerHelper.js
var promoBannerHelper = __webpack_require__(65125);
;// CONCATENATED MODULE: ./components/PromoBanner/v2/PromoBanner.jsx









const PromoBanner = (props)=>{
    var ref, ref1, ref2;
    const { setPromoData =()=>{} , xfLink ="" , col =0 , position =0 , width =0 , promoJson ={} , promoIndex =0 , parent ="" , onFilter =()=>{}  } = props;
    const [data, setData] = (0,react.useState)({
        imgUrl: "",
        desc: "",
        ctaText: "",
        ctaLink: "",
        position: "",
        promoBg: "",
        fontColor: "inherit"
    });
    const [dynamicId, setDynamicId] = (0,react.useState)("");
    const promoDesc = (0,react.useRef)(null);
    const buttonStyle = {
        color: data.fontColor,
        borderColor: data.fontColor
    };
    const [actionLink, setActionLink] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        getXfData();
    }, [
        xfLink,
        width
    ]);
    (0,react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.desc) {
            const dynamicId = (0,helper/* createIdFromString */.ZT_)(data === null || data === void 0 ? void 0 : data.desc);
            setDynamicId(dynamicId);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.desc
    ]);
    (0,react.useEffect)(()=>{
        if (data === null || data === void 0 ? void 0 : data.ctaLink) {
            (0,utils_location/* getShortenedUrl */.Pp)(data === null || data === void 0 ? void 0 : data.ctaLink).then((res)=>setActionLink(res));
        }
    }, [
        data
    ]);
    const setPromoJsonData = async function() {
        let jsonData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (jsonData) {
            var _ctaLink;
            const shortenedCtaLink = await (0,utils_location/* getShortenedUrl */.Pp)((_ctaLink = jsonData.ctaLink) !== null && _ctaLink !== void 0 ? _ctaLink : "");
            var _imageUrl, _title, _ctaLabel, _ctaLabel1, _title1, _assetPath, ref, _fontColor;
            const result = {
                imgUrl: (_imageUrl = jsonData.imageUrl) !== null && _imageUrl !== void 0 ? _imageUrl : "",
                desc: (_title = jsonData.title) !== null && _title !== void 0 ? _title : "",
                altText: jsonData.isDecorativeTeaser !== "true" ? jsonData.altText : "",
                ctaText: (_ctaLabel = jsonData.ctaLabel) !== null && _ctaLabel !== void 0 ? _ctaLabel : "",
                ctaLink: (shortenedCtaLink === null || shortenedCtaLink === void 0 ? void 0 : shortenedCtaLink.includes(".html")) ? shortenedCtaLink : "".concat(shortenedCtaLink, ".html"),
                ctaAriaLabel: "".concat((_ctaLabel1 = jsonData.ctaLabel) !== null && _ctaLabel1 !== void 0 ? _ctaLabel1 : "", " ").concat((0,helper/* sanitizeText */.oOy)((_title1 = jsonData.title) !== null && _title1 !== void 0 ? _title1 : "")),
                assetPath: (_assetPath = jsonData.assetPath) !== null && _assetPath !== void 0 ? _assetPath : "",
                position: position,
                infoTextAlign: (ref = width > 1023 ? jsonData.contentPosition : jsonData.mobileContentPosition) !== null && ref !== void 0 ? ref : "dead-center",
                promoBg: getGradiant(jsonData),
                fontColor: (_fontColor = jsonData.fontColor) !== null && _fontColor !== void 0 ? _fontColor : "inherit",
                isNewTab: jsonData.isNewTab === "true",
                isBannerLink: jsonData.linkAll === "true",
                isSmartCrop: jsonData.presetType === "smartcrop"
            };
            setData(result);
            if (setPromoData) {
                setPromoData(result);
            }
        } else if (setPromoData) {
            setPromoData({
                position: position
            });
        }
    };
    const getXfData = async ()=>{
        if (promoJson && Object.keys(promoJson).length > 0) {
            setPromoJsonData(promoJson);
        } else {
            const link = xfLink === null || xfLink === void 0 ? void 0 : xfLink.split(".html")[0];
            if (link) {
                try {
                    const data = await (0,promoBannerHelper/* getPromoData */.G)(link);
                    setPromoJsonData(data);
                } catch (error) {
                    console.error(error);
                }
            }
        }
    };
    const getGradiant = (promoRes)=>{
        const gradientData = width > 767 & width < 1024 ? Array.isArray(promoRes.mobileGradientPosition) ? promoRes.mobileGradientPosition : [
            promoRes.mobileGradientPosition
        ] : Array.isArray(promoRes.gradientPosition) ? promoRes.gradientPosition : [
            promoRes.gradientPosition
        ];
        let gradientBg = "";
        let gradientPos = "";
        const toColor = "".concat(promoRes.opacityColor).concat(Math.floor((width > 767 ? promoRes.gradientOpacity : promoRes.tintOverlayValue) / 100 * 255).toString(16).padStart(2, 0));
        if (width > 767) {
            gradientData === null || gradientData === void 0 ? void 0 : gradientData.forEach((pos, i)=>{
                if (pos === "topToBottom") {
                    gradientPos = "to bottom";
                } else if (pos === "bottomToTop") {
                    gradientPos = "to top";
                } else if (pos === "leftToRight") {
                    gradientPos = "to right";
                } else if (pos === "radialCenterOut") {
                    gradientPos = "circle";
                }
                gradientBg = gradientBg + (i > 0 ? ", " : "") + "".concat(pos === "radialCenterOut" ? "radial-gradient" : "linear-gradient", "(").concat(gradientPos, ", ").concat(promoRes.opacityColor + "00", " 0%, ").concat(toColor, " 100%)");
            });
        } else {
            gradientBg = toColor;
        }
        return gradientBg !== "" ? gradientBg : "rgba(0,0,0,0)";
    };
    const onBannerClick = (event)=>{
        if (data.isBannerLink) {
            handlePromoBannerClick(event, data);
            window.open(data.ctaLink, data.isNewTab ? "_blank" : "");
        }
    };
    const ctatitle = data === null || data === void 0 ? void 0 : (ref = data.ctaText) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    let eventInfo;
    if ( true && ((ref1 = window.location) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pathname) === null || ref2 === void 0 ? void 0 : ref2.includes("search"))) {
        eventInfo = {
            eventAction: "search results:products:main content area:".concat(ctatitle),
            eventName: "search results:products:main content area:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "search",
            internalLinkType: "search results:internal campaign",
            internalLinkZoneName: "search results:products:main content area",
            internalLinkURL: window.location.origin + data.ctaLink,
            clickInternalLinks: "true"
        };
    } else if ((parent === null || parent === void 0 ? void 0 : parent.toLowerCase()) === constants.dynamicSearch) {
        eventInfo = {
            eventAction: "search results:products:main content area:".concat(ctatitle),
            eventName: "search results:products:main content area:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "suggested search",
            internalLinkType: "suggested search results:internal campaign",
            internalLinkZoneName: "suggested search results:top products results",
            internalLinkURL:  true ? window.location.origin + data.ctaLink : 0,
            clickInternalLinks: "true"
        };
    } else {
        eventInfo = {
            eventAction: "plp:".concat(ctatitle),
            eventName: "plp:".concat(ctatitle),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: ctatitle,
            internalLinkPosition: "plp",
            internalLinkType: "plp:internal campaign",
            internalLinkZoneName: "plp:promo tiles",
            internalLinkURL:  true ? window.location.origin + data.ctaLink : 0,
            clickInternalLinks: "true"
        };
    }
    const scrollToTop = ()=>{
        const scrollStep = -window.scrollY / (1000 / 15 // scroll speed here
        );
        const scrollInterval = setInterval(()=>{
            if (window.scrollY !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
            }
        }, 15);
    };
    const handlePromoBannerClick = function(event) {
        let data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        onFilter([]);
        if (actionLink === window.location.pathname) {
            scrollToTop();
        }
        event.stopPropagation();
        if (window.adobeDataLayer) {
            var ref;
            const { adobeDataLayer: { getState  } = {}  } = window;
            const page = getState && getState("page") || {};
            const componentInfo = {
                componentID: window.location.href,
                componentLocation: window.location.pathname.includes("search") ? "search results:promo tiles" : "plp:promo tiles",
                componentMessage: "promo-".concat(promoIndex),
                componentName: (ref = data === null || data === void 0 ? void 0 : data.desc.replace(/<\/?[^>]+(>|$)/g, " ").replace(/(\r\n|\n|\r)/gm, "").replace(/&nbsp;/g, " ")) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                componentType: "internal campaign"
            };
            const eventDetails = {
                event: "cmp:click",
                eventInfo,
                componentInfo,
                page
            };
            window.adobeDataLayer.push(eventDetails);
        }
    };
    var _fontColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((v1_index_module_default()).productPromoBanner),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "plp-promo-banner wow animate__fadeInUp ".concat(col === 2 || col === 3 ? "--fixed-height" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                role: data.isBannerLink ? "link" : "",
                tabIndex: data.isBannerLink ? 0 : -1,
                onClick: onBannerClick,
                className: "plp-promo-banner__layout --col-".concat(col !== null && col !== void 0 ? col : 1),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "plp-promo-banner__image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                            imgUrl: data === null || data === void 0 ? void 0 : data.imgUrl,
                            alt: data === null || data === void 0 ? void 0 : data.desc,
                            uniqueId: dynamicId
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "plp-promo-banner__info-bg",
                        style: {
                            background: "".concat(data.promoBg)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "plp-promo-banner__info plp-promo-banner__info-".concat(data.infoTextAlign),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: promoDesc,
                                className: "plp-promo-banner__desc",
                                style: {
                                    color: "".concat((_fontColor = data.fontColor) !== null && _fontColor !== void 0 ? _fontColor : "")
                                },
                                children: (0,helper/* nbspSanitizeInnerHtml */.E9Q)(data.desc)
                            }),
                            actionLink !== "" && (actionLink === window.location.pathname ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "plp-promo-banner__button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "button",
                                    customClass: "plp-promo-banner__cta",
                                    type: "ghost",
                                    size: "small",
                                    label: data.ctaText,
                                    ariaLabel: data.ctaAriaLabel,
                                    onClick: (event)=>handlePromoBannerClick(event, data),
                                    style: buttonStyle,
                                    useDefaultClass: true
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "plp-promo-banner__button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    role: "link",
                                    customClass: "plp-promo-banner__cta",
                                    type: "ghost",
                                    size: "small",
                                    to: actionLink,
                                    label: data.ctaText,
                                    ariaLabel: data.ctaAriaLabel,
                                    onClick: (event)=>handlePromoBannerClick(event, data),
                                    style: buttonStyle,
                                    useDefaultClass: true
                                })
                            }))
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v2_PromoBanner = (PromoBanner);

// EXTERNAL MODULE: ./components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(17169);
// EXTERNAL MODULE: ./components/PartsViewer/v2/PartsViewer.jsx + 182 modules
var v2_PartsViewer = __webpack_require__(70159);
// EXTERNAL MODULE: ./hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83886);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductListView/index.jsx

























const ProductListView = (props)=>{
    const { facets , filterview ="showFilter" , staticTexts , sorts , selectedSort , loading , data , onSort , onFilter , totalResults , onLoadMore , curRows , displayPrint , displayShare , onRows , productsPerPage , facetLabels , colors , info , isLandscape , defaultImageTag , hoverImageTag , favorites , currFilters , presetConfigs , fusionQueryId , isGrouped , promoLayout , xfHtml , promoPlacementMobile , promoPlacementDesktop , compareData , promoJson , setPromoData , promoData , sessionId ="" , plpBadge ={} , presentOnDesktop ="" , presentOnMobile ="" , savedListLineItems ={}  } = props;
    const { currencySign  } = info;
    const [width] = (0,useWindowResize/* default */.Z)();
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const initialPartData = {
        productId: "",
        partId: "",
        isShowModal: false
    };
    const [swatchCount, setSwatchCount] = (0,react.useState)(width > 812 ? 7 : 5);
    const plpRef = (0,react.useRef)(null);
    const filterModalWindow = (0,react.useRef)(null);
    const [showFilter, setShowFilter] = (0,react.useState)(width >= 992 ? filterview === "showFilter" : false);
    const [rowCols, setRowCols] = (0,react.useState)(width <= 1280 ? 2 : 3);
    const [partData, setPartsData] = (0,react.useState)({
        ...initialPartData
    });
    const [svgFileMap, setSvgFileMap] = (0,react.useState)([]);
    const { featureFlags  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2: isPartsViewerV2Enabled = false  } = featureFlags;
    const filterClass = classnames_default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !showFilter,
        "product-listing__filter--modal": showFilter
    });
    const tileClass = classnames_default()({
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !showFilter
    });
    (0,react.useEffect)(()=>{
        if (width <= 1280) {
            setRowCols(2);
        } else {
            setRowCols(3);
        }
    }, [
        isLandscape,
        width
    ]);
    (0,react.useEffect)(()=>{
        setShowFilter(width >= 992 ? filterview === "showFilter" : false);
    }, [
        filterview
    ]);
    (0,react.useEffect)(()=>{
        if (!showFilter && (width < 992 || lib/* isMobile */.tq || lib/* isTablet */.Em)) {
            var ref;
            (ref = document.getElementById("showFilter")) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        showFilter
    ]);
    // calculate promo position
    const col = width < 768 ? {
        "one-column": "promo-col-3",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : width > 768 && width < 1281 ? {
        "one-column": "promo-col-1",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : {
        "one-column": "promo-col-1",
        "two-column": "promo-col-2",
        "three-column": "promo-col-3"
    };
    const colVal = {
        "one-column": 1,
        "two-column": 2,
        "three-column": 3
    };
    const row = lib/* isMobile */.tq ? parseInt(promoPlacementMobile) : parseInt(promoPlacementDesktop);
    const position = width <= 1280 ? rowCols === 1 ? row - 1 : row * rowCols - (colVal[promoLayout] === 1 && width > 767 ? 1 : 2) : row * rowCols - colVal[promoLayout];
    const executeScroll = ()=>{
        var ref;
        plpRef === null || plpRef === void 0 ? void 0 : (ref = plpRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(()=>{
        const handleResize = ()=>setSwatchCount((0,helper/* getSwatchCount */.m3S)(true));
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const handleKeyPress = (e)=>{
        if (width < 992) {
            keyPress(e, filterModalWindow, setShowFilter);
        }
    };
    const handleBackToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setTimeout(()=>{
            var ref, ref1, ref2;
            (ref = plpRef.current) === null || ref === void 0 ? void 0 : ref.setAttribute("tabindex", "-1");
            (ref1 = plpRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
            (ref2 = plpRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeAttribute("tabindex");
        }, 300);
    };
    const handleSort = (sort)=>{
        onSort(sort);
        executeScroll();
    };
    const handleOnClickPartsDiagramLink = (data)=>{
        const getPartId = get_default()(data, "ProductResource.InteractiveSVG.resourceName_ss", "");
        const resourceTitles = get_default()(data, "ProductResource.InteractiveSVG.resourceTitle_ss", "");
        const partId = Array.isArray(getPartId) ? getPartId[0] : getPartId;
        setPartsData({
            partId,
            productId: data === null || data === void 0 ? void 0 : data.ProductProductNo_s,
            isShowModal: true
        });
        const partLinks = (0,helper/* organizeData */.U2t)(getPartId, resourceTitles, "Service Parts Diagram", "PART");
        setSvgFileMap(partLinks);
    };
    const onCloseModal = ()=>{
        setPartsData({
            ...initialPartData,
            isShowModal: false
        });
    };
    let promoIndex = 0;
    let priceFilterSrLabel = staticTexts.ariaLabelZeroResults;
    if (totalResults && Number(totalResults) > 0) {
        priceFilterSrLabel = Number(totalResults) === 1 ? staticTexts.ariaLabelFilteredResult(totalResults) : staticTexts.ariaLabelFilteredResults(totalResults);
    }
    if (currFilters === null || currFilters === void 0 ? void 0 : currFilters.length) {
        const totalAppliedFilter = currFilters.map((filter)=>{
            return filter === null || filter === void 0 ? void 0 : filter.value;
        });
        priceFilterSrLabel = (totalAppliedFilter === null || totalAppliedFilter === void 0 ? void 0 : totalAppliedFilter.flat().length) === 1 ? priceFilterSrLabel + " " + staticTexts.ariaLabelAppliedFilter : priceFilterSrLabel + " " + staticTexts.ariaLabelAppliedFilters;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-listing",
                ref: plpRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stickyNavHeader["default"], {
                        showFilter: showFilter,
                        rowCols: rowCols,
                        setShowFilter: setShowFilter,
                        setRowCols: setRowCols,
                        staticTexts: staticTexts,
                        sorts: sorts,
                        selectedSort: selectedSort,
                        handleSort: handleSort,
                        totalResults: totalResults
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-plp-container product-listing__tiles",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing__row d-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "filter-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: filterClass,
                                        "aria-modal": true,
                                        ref: filterModalWindow,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "product-listing__filter--sticky",
                                            "aria-hidden": !showFilter,
                                            onKeyDown: handleKeyPress,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "screen-reader-hidden-label",
                                                    "aria-live": "assertive",
                                                    "aria-label": priceFilterSrLabel
                                                }),
                                                facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter["default"], {
                                                    tabIndex: "0",
                                                    texts: staticTexts,
                                                    close: setShowFilter,
                                                    showFilter: showFilter,
                                                    addToUrl: true,
                                                    showSort: width <= 991,
                                                    sort: sorts,
                                                    selectedSort: selectedSort,
                                                    facetData: facets,
                                                    totalResults: totalResults,
                                                    loading: loading,
                                                    colors: colors,
                                                    facetLabels: facetLabels,
                                                    onFilter: onFilter,
                                                    onSortChange: handleSort,
                                                    displayShare: displayShare,
                                                    displayPrint: displayPrint,
                                                    currFilters: currFilters
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: tileClass,
                                        children: (data === null || data === void 0 ? void 0 : data.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-listing__no-results",
                                            dangerouslySetInnerHTML: {
                                                __html: browser_default().sanitize(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.noResultsMssg)
                                            }
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-listing__row row-cols-".concat(rowCols),
                                                    children: data === null || data === void 0 ? void 0 : data.map((product, i)=>{
                                                        // console.log( xfHtml && (i + 1) % position === 0)
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-listing__tile",
                                                                    id: product["masterCustomerFacingSKU_s"],
                                                                    children: i < 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile/* default */.Z, {
                                                                            rowCols: rowCols,
                                                                            tabIndex: "0",
                                                                            loading: loading,
                                                                            data: product,
                                                                            mapImageToColor: true,
                                                                            texts: staticTexts,
                                                                            lite: !isLandscape && lib/* isMobile */.tq && rowCols === 2,
                                                                            addToCompare: utils_product/* addToCompareProduct */.dX,
                                                                            removeFromCompare: utils_product/* removeFromCompareProduct */.Zj,
                                                                            compareData: compareData,
                                                                            defaultImage: defaultImageTag,
                                                                            hoverImage: hoverImageTag,
                                                                            currencySign: currencySign,
                                                                            isGrouped: isGrouped,
                                                                            swatchCount: swatchCount,
                                                                            favorites: favorites,
                                                                            savedListLineItems: savedListLineItems,
                                                                            currFilters: currFilters,
                                                                            selectedSort: selectedSort,
                                                                            plpPage: true,
                                                                            index: i,
                                                                            presetConfigs: presetConfigs,
                                                                            fusionQueryId: fusionQueryId,
                                                                            parent: "PLP",
                                                                            sessionId: sessionId,
                                                                            plpBadge: plpBadge,
                                                                            isPartsDiagramLinkVisible: true,
                                                                            handleOnClickPartsDiagramLink: ()=>{
                                                                                handleOnClickPartsDiagramLink(product);
                                                                            }
                                                                        })
                                                                    }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s, "-LAZY")) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                                            className: "kf-lazyload-wrapper",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile/* default */.Z, {
                                                                                rowCols: rowCols,
                                                                                tabIndex: "0",
                                                                                loading: loading,
                                                                                data: product,
                                                                                mapImageToColor: true,
                                                                                texts: staticTexts,
                                                                                lite: !isLandscape && lib/* isMobile */.tq && rowCols === 2,
                                                                                addToCompare: utils_product/* addToCompareProduct */.dX,
                                                                                removeFromCompare: utils_product/* removeFromCompareProduct */.Zj,
                                                                                compareData: compareData,
                                                                                defaultImage: defaultImageTag,
                                                                                hoverImage: hoverImageTag,
                                                                                currencySign: currencySign,
                                                                                isGrouped: isGrouped,
                                                                                swatchCount: swatchCount,
                                                                                favorites: favorites,
                                                                                savedListLineItems: savedListLineItems,
                                                                                currFilters: currFilters,
                                                                                selectedSort: selectedSort,
                                                                                plpPage: true,
                                                                                index: i,
                                                                                presetConfigs: presetConfigs,
                                                                                fusionQueryId: fusionQueryId,
                                                                                parent: "PLP",
                                                                                sessionId: sessionId,
                                                                                plpBadge: plpBadge,
                                                                                isPartsDiagramLinkVisible: true,
                                                                                handleOnClickPartsDiagramLink: ()=>{
                                                                                    handleOnClickPartsDiagramLink(product);
                                                                                }
                                                                            })
                                                                        })
                                                                    }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s, "-LAZY"))
                                                                }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s)),
                                                                xfHtml && getIsPresentOnDevice(presentOnDesktop, presentOnMobile) && (i + 1) % position === 0 && ((data === null || data === void 0 ? void 0 : data.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat(col[promoLayout], " product-listing__tile"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PromoBanner, {
                                                                        promoJson: promoJson,
                                                                        xfLink: xfHtml,
                                                                        col: colVal[promoLayout],
                                                                        setPromoData: setPromoData,
                                                                        position: i,
                                                                        promoIndex: ++promoIndex,
                                                                        promoData: promoData,
                                                                        smartCrop: smartCrop,
                                                                        width: width,
                                                                        onFilter: onFilter
                                                                    })
                                                                }) : (data === null || data === void 0 ? void 0 : data.length) - 1 === i && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat(col[promoLayout], " product-listing__tile"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PromoBanner, {
                                                                        promoJson: promoJson,
                                                                        xfLink: xfHtml,
                                                                        col: colVal[promoLayout],
                                                                        setPromoData: setPromoData,
                                                                        position: i,
                                                                        promoIndex: ++promoIndex,
                                                                        promoData: promoData,
                                                                        smartCrop: smartCrop,
                                                                        width: width,
                                                                        onFilter: onFilter
                                                                    })
                                                                }))
                                                            ]
                                                        }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s));
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                    page: "plp",
                                                    totalResults,
                                                    staticTexts,
                                                    onLoadMore,
                                                    curRows,
                                                    data,
                                                    displayPrint,
                                                    displayShare,
                                                    productsPerPage,
                                                    onRows,
                                                    handleBackToTop,
                                                    width
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            isPartsViewerV2Enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsViewer/* default */.Z, {
                productId: partData === null || partData === void 0 ? void 0 : partData.productId,
                partId: partData === null || partData === void 0 ? void 0 : partData.partId,
                showModal: partData === null || partData === void 0 ? void 0 : partData.isShowModal,
                page: "PLP results",
                onClose: onCloseModal,
                fileMap: svgFileMap
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                productId: partData === null || partData === void 0 ? void 0 : partData.productId,
                partId: partData === null || partData === void 0 ? void 0 : partData.partId,
                showModal: partData === null || partData === void 0 ? void 0 : partData.isShowModal,
                page: "PLP results",
                onClose: onCloseModal
            })
        ]
    });
};
/* harmony default export */ var v2_ProductListView = (ProductListView);

// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./components/ProductList/v2/PLPLoader/index.jsx
var PLPLoader = __webpack_require__(80498);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./hooks/usePrevious.js
var usePrevious = __webpack_require__(67166);
// EXTERNAL MODULE: ./components/ProductList/v2/analytics.js
var analytics = __webpack_require__(58143);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./components/Search/v1/ProductsTab/helper.js
var ProductsTab_helper = __webpack_require__(34955);
;// CONCATENATED MODULE: ./components/ProductList/v2/ProductList.jsx

























const ProductList = (props)=>{
    var ref;
    const isServer = "object" === "undefined";
    const isSsr = (0,useIsSsr/* default */.Z)();
    const router = (0,next_router.useRouter)();
    let plp;
    let compareData;
    const { eventHandler  } = props;
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const DEFAULT_PAGINATION_VALUE = constants.DEFAULT_PRODUCT_COUNT_PLP;
    const { data: componentProps  } = props;
    const { access_token: accessToken , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { saveToListLineItems  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { categoryKey , attributevalue , attributeName , isServiceParts =""  } = componentProps;
    if (isServer) {
        var ref1;
        plp = eventHandler === null || eventHandler === void 0 ? void 0 : (ref1 = eventHandler.store) === null || ref1 === void 0 ? void 0 : ref1.plp;
        compareData = {};
    } else {
        // eslint-disable-next-line
        plp = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
        // eslint-disable-next-line
        compareData = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    }
    const productlistState = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv);
    const { visualNavAppliedFilters =[]  } = productlistState;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { data , total =0 , facets , facetLabels , status , initialLoad , colors , grouped , fusion ={}  } = plp;
    const rowsInitialValue = (0,utils_product/* getRowsInitialValue */.U9)();
    const [paginationState, setPaginationState] = (0,react.useState)({
        rows: rowsInitialValue,
        start: 0
    });
    const { rows , start  } = paginationState;
    const [promoData, setPromoData] = (0,react.useState)({
        promos: [],
        isUpdate: false
    });
    const prevRows = (0,usePrevious/* default */.Z)(rows);
    const [isLoadMore, setIsLoadMore] = (0,react.useState)(false);
    const [general, setGeneral] = (0,react.useState)({
        brandName: "",
        badgeText: ""
    });
    const [sessionId, setSessionId] = (0,react.useState)("") // setting initial state of sessionId
    ;
    // Need to read from env file
    const [info, setInfo] = (0,react.useState)({
        currencyCode: "USD",
        currencySign: "$",
        locale: "en-US"
    });
    const [state, setState] = (0,react.useState)({
        position: "",
        promoJson: {}
    });
    const [caFrInitialFilterLoad, setCaFrInitialFilterLoad] = (0,react.useState)(false);
    const [caFrInitialFilters, setCaFrInitialFilters] = (0,react.useState)([]);
    const [fusionQueryId, setFusionQueryId] = (0,react.useState)("");
    const [curFilterQueries, setCurFilterQueries] = (0,react.useState)(null);
    const prevCurFilterQueries = (0,usePrevious/* default */.Z)(curFilterQueries);
    const [persona, setPersona] = (0,react.useState)("GST");
    const [isFusionLoaded, setIsFusionLoaded] = (0,react.useState)(false);
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    const [filterDataPopulated, setFilterDataPopulated] = (0,react.useState)(false);
    const [plpBadge, setPlpBadge] = (0,react.useState)({});
    const [filterCleared, setFilterCleared] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        (0,config/* getConfig */.i)().then((config)=>{
            const { plpConfigurations: { myArrayList: plpBadgeList = []  } = {}  } = config;
            const locale = get_default()(config, "internationalization.locale", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const brandName = get_default()(config, "general.siteName");
            var ref;
            const displayOrderBadges = (ref = plpBadgeList.find((item)=>item.map.Key === "displayOrderBadges")) !== null && ref !== void 0 ? ref : {};
            const { map: { Values: { myArrayList: displayOrderBadgeList = []  } = {}  } = {}  } = displayOrderBadges;
            const plpBadges = {};
            displayOrderBadgeList.forEach((item)=>{
                plpBadges[item] = (0,helper/* getBadgeValue */.FcF)(item, plpBadgeList);
            });
            const badgeText = {
                new: get_default()(config, "general.newBadgeName", ""),
                onSale: get_default()(config, "general.saleBadgeName", ""),
                exclusive: get_default()(config, "general.exclusiveBadgeName", "")
            };
            const marketParamValues = get_default()(config, "marketParamValues", {});
            const { general: { serviceParts =""  } = {}  } = config;
            const general = {
                brandName: brandName,
                badgeText: badgeText,
                serviceParts
            };
            const info = {
                locale: locale,
                currencyCode: currencyCode,
                currencySign: currencySign,
                marketParamValues
            };
            const filterQuery = (0,helper/* getAllFilterQueries */.ud4)(componentProps, fusion, marketParamValues);
            const urlParams = window.location.search;
            if (locale === "fr-CA" && urlParams && !caFrInitialFilterLoad) {
                setCaFrInitialFilters([
                    ...filterQuery
                ]);
                generateListingUrl(false, true, true);
            } else {
                dispatch((0,productListSlice/* setCurrentAppliedfilters */.Li)(filterQuery));
                setCurFilterQueries(filterQuery);
            }
            setGeneral(general);
            setInfo(info);
            setPlpBadge({
                plpBadges,
                displayOrderBadgeList
            });
            const cookie = document === null || document === void 0 ? void 0 : document.cookie;
            const cookieArray = cookie === null || cookie === void 0 ? void 0 : cookie.split(";");
            const sessionCookie = cookieArray.filter((item)=>{
                return item === null || item === void 0 ? void 0 : item.includes("session#");
            })[0];
            const sessionIdString = sessionCookie === null || sessionCookie === void 0 ? void 0 : sessionCookie.split("|")[1];
            setSessionId(sessionIdString === null || sessionIdString === void 0 ? void 0 : sessionIdString.split("#")[1]) // setting the value of session id from cookie information
            ;
        });
    }, [
        isSsr,
        router
    ]);
    (0,react.useEffect)(()=>{
        if (visualNavAppliedFilters.length) {
            if (visualNavAppliedFilters[0].add) {
                setCurFilterQueries(visualNavAppliedFilters);
            } else {
                if (curFilterQueries) {
                    const finalFilters = [];
                    curFilterQueries.forEach((filter)=>{
                        var ref, ref1;
                        if ((filter === null || filter === void 0 ? void 0 : filter.facet) === ((ref = visualNavAppliedFilters[0]) === null || ref === void 0 ? void 0 : ref.facet) && (filter === null || filter === void 0 ? void 0 : filter.value.length) > visualNavAppliedFilters[0].value.length) {
                            var ref2, ref3;
                            const display = filter === null || filter === void 0 ? void 0 : filter.display;
                            const completeValues = filter === null || filter === void 0 ? void 0 : filter.value;
                            const displayValues = [
                                ...display
                            ];
                            const values = [
                                ...completeValues
                            ];
                            const indexDis = displayValues.indexOf((ref2 = visualNavAppliedFilters[0]) === null || ref2 === void 0 ? void 0 : ref2.display[0]);
                            const indexVal = values.indexOf((ref3 = visualNavAppliedFilters[0]) === null || ref3 === void 0 ? void 0 : ref3.value[0]);
                            if (indexDis !== -1) {
                                displayValues.splice(indexDis, 1);
                            }
                            if (indexVal !== -1) {
                                values.splice(indexVal, 1);
                            }
                            finalFilters.push({
                                ...filter,
                                display: displayValues,
                                value: values
                            });
                        } else if ((filter === null || filter === void 0 ? void 0 : filter.facet) !== ((ref1 = visualNavAppliedFilters[0]) === null || ref1 === void 0 ? void 0 : ref1.facet)) {
                            finalFilters.push(filter);
                        }
                    });
                    setCurFilterQueries(finalFilters);
                }
            }
        }
    }, [
        visualNavAppliedFilters
    ]);
    (0,react.useEffect)(()=>{
        if (caFrInitialFilterLoad) {
            var ref;
            const facetKyes = (ref = Object.keys(facetLabels)) !== null && ref !== void 0 ? ref : [];
            const caQueryFilters = caFrInitialFilters.map((filter)=>{
                const filterkey = facetKyes.find((facetKey)=>{
                    return facetLabels[facetKey] === filter.facet.replaceAll("_", " ");
                });
                return {
                    ...filter,
                    ...filterkey && {
                        facet: filterkey
                    }
                };
            });
            setCurFilterQueries(caQueryFilters !== null && caQueryFilters !== void 0 ? caQueryFilters : []);
        }
    }, [
        caFrInitialFilterLoad
    ]);
    const staticTexts = i18n_useProductListi18n({
        componentProps,
        total: total,
        generalRef: general
    });
    const [selectedSort, setSelectedSort] = (0,react.useState)({
        name: staticTexts.featured,
        query: ""
    });
    const prevSort = (0,usePrevious/* default */.Z)(selectedSort);
    const sorts = [
        {
            name: staticTexts.featured,
            query: ""
        },
        {
            name: staticTexts.priceDesc,
            query: "price+desc"
        },
        {
            name: staticTexts.priceAsc,
            query: "price+asc"
        },
        {
            name: staticTexts.atoz,
            query: "".concat(grouped ? "CollapseSort_s+asc" : "NonCollapseSort_s+asc")
        },
        {
            name: staticTexts.ztoa,
            query: "".concat(grouped ? "CollapseSort_s+desc" : "NonCollapseSort_s+desc")
        }
    ];
    const handleSort = (selectedSort)=>{
        (0,helper/* replaceSearchUrl */.CjH)("sort", selectedSort.query);
        setPaginationState((state)=>({
                ...state,
                start: 0
            }));
        setSelectedSort(selectedSort);
    };
    const handleLoadMore = ()=>{
        setRowsSession(start + rows + rows);
        setPaginationState((state)=>({
                ...state,
                start: start + rows
            }));
        setIsLoadMore(true);
    };
    const setRowsSession = (rows)=>{
        if (sessionStorage.rows) {
            const rowStorage = JSON.parse(sessionStorage.rows);
            rowStorage[window.location.pathname] = rows;
            sessionStorage.rows = JSON.stringify(rowStorage);
        } else {
            sessionStorage.rows = JSON.stringify({
                [window.location.pathname]: rows
            });
        }
    };
    const handleRows = (rows)=>{
        setPaginationState({
            rows,
            start: 0
        });
        setRowsSession(rows);
    };
    (0,react.useEffect)(()=>{
        if (accessToken && curFilterQueries !== null) {
            var ref, ref1;
            const personaTemp = (user === null || user === void 0 ? void 0 : (ref = user.persona) === null || ref === void 0 ? void 0 : ref.length) > 0 ? (ref1 = user === null || user === void 0 ? void 0 : user.persona[0]) === null || ref1 === void 0 ? void 0 : ref1.split(":")[1] : "GST";
            setPersona(personaTemp);
            window.authAccessToken = accessToken;
            // will trigger from handleLoadMore
            if (start) {
                generateListingUrl(isLoadMore, false);
            } else if (start === 0 && rows && !!prevRows && prevRows > rows) {
                generateListingUrl(false, true);
            } else if (start === 0 && rows && !!prevRows && prevRows !== rows) {
                generateListingUrl(false, false);
            } else if (curFilterQueries.length > 0 || (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query)) {
                generateListingUrl();
            } else if (curFilterQueries.length === 0 && prevCurFilterQueries !== null) {
                generateListingUrl();
            } else if (prevSort && (prevSort === null || prevSort === void 0 ? void 0 : prevSort.query) !== (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query)) {
                generateListingUrl();
            } else if (prevRows === rows && rows > DEFAULT_PAGINATION_VALUE || personaTemp !== "GST") {
                generateListingUrl();
            } else if ((curFilterQueries === null || curFilterQueries === void 0 ? void 0 : curFilterQueries.length) === 0) {
                generateListingUrl();
            }
        }
    }, [
        start,
        rows,
        accessToken,
        curFilterQueries,
        selectedSort,
        isLoadMore
    ]);
    (0,react.useEffect)(()=>{
        if (!(attributevalue && attributeName)) {
            if (!data || data && data.length === 3 && total > 3) {
                generateListingUrl();
            }
        }
    }, [
        data,
        total,
        attributevalue,
        attributeName
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fusion) && accessToken && !isFusionLoaded) {
            setIsFusionLoaded(true);
            const fusionQueryId = fusion === null || fusion === void 0 ? void 0 : fusion.fusionQueryId;
            setFusionQueryId(fusionQueryId);
            const sortUrl = (0,helper/* getSortFromUrl */.aN0)();
            const sortQuery = (0,helper/* getSelectedSort */.a4K)(staticTexts, sortUrl);
            setSelectedSort(sortQuery);
            if (componentProps) {
                if (componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfLink) {
                    setState({
                        ...state,
                        xfHtml: componentProps.xfLink
                    });
                } else {
                // log.warn("Promo banner xF is not configured")
                }
            } else {
            // log.warn("Product List: Get URL Property not found")
            }
        }
    }, [
        fusion,
        accessToken
    ]);
    // Function to generate the plp request url.
    const generateListingUrl = async function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, initialCaFr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        const queries = curFilterQueries;
        if (!update) {
            setPaginationState({
                ...paginationState,
                start: 0
            });
            setPromoData({
                promos: [],
                isUpdate: false
            });
        }
        const fq = [];
        const persona = (0,helper/* getUserPersona */.shu)();
        queries === null || queries === void 0 ? void 0 : queries.forEach((q)=>{
            var ref;
            const tag = '{!tag="'.concat(q.facet, '"}');
            if (!q.facet.match(/^\*{2}/)) {
                var ref1;
                q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 || ((ref1 = q.facet) === null || ref1 === void 0 ? void 0 : ref1.indexOf("discountedPriceStartingAt")) === 0 ? fq.push(encodeURIComponent("".concat('{!tag="priceList.'.concat(persona, '.finalPrice_d"}') + "priceList.".concat(persona, ".finalPrice_d"), ":(").concat(q.value.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
                return;
            }
            q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 || ((ref = q.facet) === null || ref === void 0 ? void 0 : ref.indexOf("discountedPriceStartingAt")) === 0 ? fq.push("".concat("priceList.".concat(persona, ".finalPrice_d").replace(/^\*{2}/, ""), ":(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
        });
        const query = {
            fq,
            rows,
            start,
            fl: constants.resourceFacetLabels.join(",")
        };
        if (selectedSort.query) {
            if (selectedSort.query === "price+asc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(plp === null || plp === void 0 ? void 0 : plp.grouped), "+asc");
            } else if (selectedSort.query === "price+desc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(plp === null || plp === void 0 ? void 0 : plp.grouped), "+desc");
            } else {
                query.sort = selectedSort.query;
            }
        }
        if (enableScroll) setDataPopulated(false);
        const globalConfig = await (0,config/* getConfig */.i)();
        const { general: { serviceParts =""  } = {}  } = globalConfig;
        const collections = isServiceParts ? serviceParts : "";
        dispatch((0,productListSlice/* getProducts */.Xp)({
            profileName: categoryKey,
            query,
            update,
            collections
        })).then(()=>{
            setFilterDataPopulated(true);
            if (initialCaFr) setCaFrInitialFilterLoad(true);
            if (enableScroll) setDataPopulated(true);
        }).catch(()=>{
            setFilterDataPopulated(true);
            if (enableScroll) setDataPopulated(false);
        });
    };
    const setPromoInfo = (promo)=>{
        const promoDataNew = [
            ...promoData.promos
        ];
        if (promo && !promoData.promos.find((item)=>item.position === promo.position)) {
            // don't push duplicates
            promoDataNew.push(promo);
        }
        setPromoData({
            promos: promoDataNew,
            isUpdate: true
        });
    };
    (0,react.useEffect)(()=>{
        // checking if all responses are recorded
        if (isSsr) return;
        const { isUpdate , promos  } = promoData;
        if (isUpdate) {
            const { position  } = state;
            const requestedPromos = [];
            data.map((item, i)=>{
                if ((i + 1) % position === 0) {
                    requestedPromos.push(i);
                }
            });
            if (requestedPromos.length === promos.length) {
                (0,analytics/* addAnalyticsShowEvent */._J)(promos, setPromoData, data);
            }
        }
    }, [
        promoData.promos,
        promoData.isUpdate,
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        // plpLoadedEvent implementation
        const { position , xfHtml  } = state;
        const { promos  } = promoData;
        if (!data || !data.length || parseInt(data.length / position) === 0 || !xfHtml) {
            (0,analytics/* addAnalyticsShowEvent */._J)(promos, setPromoData, data);
        } else {
            // checking if all responses are recorded
            const requestedPromos = [];
            data.map((item, i)=>{
                if ((i + 1) % position === 0) {
                    requestedPromos.push(i);
                }
            });
            if (requestedPromos.length === 0) {
                (0,analytics/* addAnalyticsShowEvent */._J)(promos, setPromoData, data);
            } else {
                const timeoutId = setTimeout(()=>{
                    (0,analytics/* addAnalyticsShowEvent */._J)(promos, setPromoData, data);
                }, 5000);
                return ()=>{
                    clearTimeout(timeoutId);
                };
            }
        }
    }, [
        data,
        state.position,
        componentProps.xfLink,
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const facetParam = urlParams.get("facets");
        // To scrollup the product list on back
        if (document.querySelector(".visual-nav")) {
            if (window.location.search.includes("&back") && window.location.search.includes("?facets") || dataPopulated && facetParam || window.location.search.includes("?facets") || filterCleared) {
                (0,ProductsTab_helper/* scrollToVisualNav */.qL)();
            }
        } else if (dataPopulated && facetParam && !document.querySelector(".visual-nav") || filterCleared && !document.querySelector(".visual-nav")) {
            (0,ProductsTab_helper/* scrollToFirstProduct */.nj)(false, true);
        } else if (window.location.search.includes("?") && !window.location.search.includes("?back") && !window.location.search.includes("?facets")) {
            scrollToTop();
        } else if (dataPopulated) {
            (0,ProductsTab_helper/* scrollToProduct */.C1)();
        }
    }, [
        dataPopulated,
        filterCleared
    ]);
    const scrollToTop = ()=>{
        window.scrollTo(0, 0);
    };
    const sendPositionToParent = (position)=>{
        setState({
            ...state,
            position: position
        });
    };
    const handleFilter = (appliedFilter)=>{
        setRowsSession(30);
        setIsLoadMore(false);
        setFilterCleared(!appliedFilter.length);
        setCurFilterQueries(appliedFilter);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isEmpty_default()(info) && (!(attributeName && attributevalue) || attributevalue && attributeName && filterDataPopulated) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-testid": "product-list",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ProductListView, {
                staticTexts: staticTexts,
                sorts: sorts,
                selectedSort: selectedSort,
                info: info,
                onLoadMore: handleLoadMore,
                curRows: rows,
                onRows: handleRows,
                onSort: handleSort,
                onFilter: handleFilter,
                totalResults: total,
                displayShare: componentProps.enableSharePlp,
                displayPrint: componentProps.enablePrintPlp,
                productsPerPage: productsPerPage,
                data: data,
                colors: colors,
                loading: initialLoad ? false : status !== "succeeded",
                ...componentProps,
                facets: facets !== null && facets !== void 0 ? facets : false,
                facetLabels: facetLabels,
                xfHtml: state.xfHtml,
                currFilters: curFilterQueries,
                // resetTitle={""} The value is not using any where, so not implemented now
                // urlTitle={""} The value is not using any where, so not implemented now
                isGrouped: grouped,
                favorites: (ref = (0,helper/* getFavouraties */.MqV)()) === null || ref === void 0 ? void 0 : ref.lineItems,
                setPromoData: setPromoInfo,
                sendPositionToParent: sendPositionToParent,
                promoData: promoData.promos,
                promoJson: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson) ? JSON.parse(componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson) : {},
                fusionQueryId: fusionQueryId,
                parent: "PLP",
                compareData: compareData,
                promoLayout: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoLayout,
                promoPlacementDesktop: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoPlacementDesktop,
                promoPlacementMobile: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoPlacementMobile,
                persona: persona,
                sessionId: sessionId,
                plpBadge: plpBadge,
                savedListLineItems: saveToListLineItems
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PLPLoader/* default */.Z, {
                staticTexts: staticTexts
            })
        })
    });
};
/* harmony default export */ var v2_ProductList = (ProductList);

// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/index.jsx + 1 modules
var UpsellInstallServices = __webpack_require__(61054);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./components/LeadGeneration/index.jsx
var LeadGeneration = __webpack_require__(80580);
;// CONCATENATED MODULE: ./pages/content/[[...page]].jsx








































const StoreDataTags = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3660).then(__webpack_require__.bind(__webpack_require__, 63660)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(63660)
            ]
    }
});
/**
 * renders home page
 * @return {JSX.Element}
 */ function Page(param) {
    let { tmpData: data , headertmp: header , footertmp: footer , ip , globalScript , footerScript , analyticsData , gbhDataLayerCustom , fullUrl , urlNames , data404 , datalayerPageName , plpData ={} , storeData ={}  } = param;
    var ref, ref1;
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { cartUrl  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [pageRedirect, setPageRedirect] = (0,react.useState)("");
    const [isScrollMarginRequired, setIsScrollMarginRequired] = (0,react.useState)(false);
    var ref2;
    const initialUrlRefValue = (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("#")) ? "#".concat((ref2 = router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.split("#")[1]) !== null && ref2 !== void 0 ? ref2 : "") : "";
    const [urlRefValue, setUrlRefValue] = (0,react.useState)(initialUrlRefValue);
    const { pageUrl ="" , redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const { scroll: defaultScrollValue  } = constants.DEFAULT_SCROLL;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    (0,usePageAuth/* default */.Z)();
    const cartCount = (0,cart/* getCartCount */.c0)();
    const ariaLabel = (0,cart/* getAriaLabel */.Xw)(t, cartCount);
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,genericSlice/* closeMenu */.Wj)());
            dispatch((0,genericSlice/* setAuthNav */.AT)(false));
        } else {
            dispatch((0,genericSlice/* openMenu */.qn)());
        }
    };
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            isAuthNavOpen,
            cartCount,
            ariaLabel,
            cartUrl,
            plp: {
                ...plpData,
                status: "succeeded"
            }
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,genericSlice/* setBrandLogoImg */.XY)(path));
            },
            closeMenu: ()=>{
                dispatch((0,genericSlice/* closeMenu */.Wj)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,genericSlice/* setActiveMainCategory */.X7)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,genericSlice/* setRegionNav */.qX)(active));
            },
            setAuthNav: (active)=>{
                dispatch((0,genericSlice/* setAuthNav */.AT)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,genericSlice/* setGlobalScripts */.n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,genericSlice/* setGlobalStyles */.cw)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (plpData) {
            dispatch((0,productListSlice/* setPlpData */.gS)({
                ...plpData,
                status: "succeeded",
                initialLoad: true
            }));
        }
        if (gbhDataLayerCustom.pageType === "plp") {
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
            return ()=>{
                dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
                dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
            };
        }
    }, [
        datalayerPageName,
        gbhDataLayerCustom,
        plpData
    ]);
    (0,react.useEffect)(()=>{
        if (pageUrl) {
            var ref;
            const containsString = constants.DISABLE_SROLL_PATH.some((str)=>pageUrl.includes(str));
            const url = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href;
            if (urlRefValue) {
                if ((url === null || url === void 0 ? void 0 : url.includes(constants.INSTALLATION_SERVICES_ASPATH)) || (url === null || url === void 0 ? void 0 : url.includes(constants.BUYING_GUIDE_ASPATH))) {
                    const element = document.querySelector("".concat(urlRefValue));
                    const offsetTop = (0,helper/* getOffsetTop */.oJS)(element) - defaultScrollValue;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: "smooth",
                        left: 0
                    });
                }
            } else if (containsString) {
                window.scrollTo({
                    top: 1,
                    behavior: "smooth"
                });
            }
        }
    }, [
        pageUrl,
        urlRefValue
    ]);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        if (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes(constants.PRIVACY_ASPATH)) {
            dispatch((0,genericSlice/* setPageIsIntercative */.Ys)(true));
        }
        if (router === null || router === void 0 ? void 0 : (ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.includes(constants.INSTALLATION_SERVICES_ASPATH)) {
            setIsScrollMarginRequired(true);
        }
        const handleHashChange = ()=>{
            const hash = window.location.hash;
            setUrlRefValue(hash);
        };
        window.addEventListener("hashchange", handleHashChange);
        return ()=>{
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,helper/* removeAndCleanLink */.xEh)(path));
        }
    }, [
        path
    ]);
    (0,react.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.replace(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react.useEffect)(()=>{
        (0,helper/* getScriptsAndStyles */.csL)(data);
    }, [
        data
    ]);
    const getStoreApplicationJsonLDData = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
        const applicationJsonLdData = {};
        const address = {};
        const geo = {};
        const weekdays = {};
        const saturday = {};
        const sunday = {};
        applicationJsonLdData["@context"] = constants.STORE_APP_LD_JSON.context;
        applicationJsonLdData["@type"] = constants.STORE_APP_LD_JSON.type;
        address["@type"] = constants.STORE_APP_LD_JSON.addressType;
        address.streetAddress = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.schema) === null || ref === void 0 ? void 0 : ref.street;
        address.addressLocality = storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.schema) === null || ref1 === void 0 ? void 0 : ref1.locality;
        address.addressRegion = storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.schema) === null || ref2 === void 0 ? void 0 : ref2.region;
        address.postalCode = storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.schema) === null || ref3 === void 0 ? void 0 : ref3.zipCode;
        address.addressCountry = storeData === null || storeData === void 0 ? void 0 : (ref4 = storeData.schema) === null || ref4 === void 0 ? void 0 : ref4.country;
        weekdays["@type"] = constants.STORE_APP_LD_JSON.openingHourType;
        weekdays.dayOfWeek = [
            constants.STORE_APP_LD_JSON.openingDays.monday,
            constants.STORE_APP_LD_JSON.openingDays.tuesday,
            constants.STORE_APP_LD_JSON.openingDays.wednesday,
            constants.STORE_APP_LD_JSON.openingDays.thursday,
            constants.STORE_APP_LD_JSON.openingDays.friday
        ];
        weekdays.opens = storeData === null || storeData === void 0 ? void 0 : (ref5 = storeData.schema) === null || ref5 === void 0 ? void 0 : ref5.weekdayOpenHour;
        weekdays.closes = storeData === null || storeData === void 0 ? void 0 : (ref6 = storeData.schema) === null || ref6 === void 0 ? void 0 : ref6.weekdayCloseHour;
        saturday["@type"] = constants.STORE_APP_LD_JSON.openingHourType;
        saturday.dayOfWeek = [
            constants.STORE_APP_LD_JSON.openingDays.saturday
        ];
        saturday.opens = storeData === null || storeData === void 0 ? void 0 : (ref7 = storeData.schema) === null || ref7 === void 0 ? void 0 : ref7.saturdayOpenHour;
        saturday.closes = storeData === null || storeData === void 0 ? void 0 : (ref8 = storeData.schema) === null || ref8 === void 0 ? void 0 : ref8.saturdayCloseHour;
        sunday["@type"] = constants.STORE_APP_LD_JSON.openingHourType;
        sunday.dayOfWeek = [
            constants.STORE_APP_LD_JSON.openingDays.sunday
        ];
        sunday.opens = storeData === null || storeData === void 0 ? void 0 : (ref9 = storeData.schema) === null || ref9 === void 0 ? void 0 : ref9.sundayOpenHour;
        sunday.closes = storeData === null || storeData === void 0 ? void 0 : (ref10 = storeData.schema) === null || ref10 === void 0 ? void 0 : ref10.sundayCloseHour;
        geo["@type"] = constants.STORE_APP_LD_JSON.geoType;
        geo.latitude = storeData === null || storeData === void 0 ? void 0 : (ref11 = storeData.schema) === null || ref11 === void 0 ? void 0 : ref11.latitude;
        geo.longitude = storeData === null || storeData === void 0 ? void 0 : (ref12 = storeData.schema) === null || ref12 === void 0 ? void 0 : ref12.longitude;
        applicationJsonLdData.name = storeData === null || storeData === void 0 ? void 0 : (ref13 = storeData.schema) === null || ref13 === void 0 ? void 0 : ref13.name;
        applicationJsonLdData.image = storeData === null || storeData === void 0 ? void 0 : (ref14 = storeData.schema) === null || ref14 === void 0 ? void 0 : ref14.image;
        applicationJsonLdData.description = storeData === null || storeData === void 0 ? void 0 : (ref15 = storeData.schema) === null || ref15 === void 0 ? void 0 : ref15.description;
        applicationJsonLdData.hasMap = storeData === null || storeData === void 0 ? void 0 : (ref16 = storeData.schema) === null || ref16 === void 0 ? void 0 : ref16.hasMap;
        applicationJsonLdData.url = storeData === null || storeData === void 0 ? void 0 : (ref17 = storeData.schema) === null || ref17 === void 0 ? void 0 : ref17.url;
        applicationJsonLdData.telephone = storeData === null || storeData === void 0 ? void 0 : (ref18 = storeData.schema) === null || ref18 === void 0 ? void 0 : ref18.telephone;
        applicationJsonLdData.priceRange = storeData === null || storeData === void 0 ? void 0 : (ref19 = storeData.schema) === null || ref19 === void 0 ? void 0 : ref19.priceRange;
        applicationJsonLdData.address = {
            ...address
        };
        applicationJsonLdData.geo = {
            ...geo
        };
        applicationJsonLdData.openingHoursSpecification = [
            {
                ...weekdays
            },
            {
                ...saturday
            },
            {
                ...sunday
            }
        ];
        return JSON.stringify(applicationJsonLdData);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* default */.Z, {
                ...data,
                fullUrl: fullUrl
            }) : null,
            (data === null || data === void 0 ? void 0 : data.templateName) === "store-detail-page" && /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: browser_default().sanitize(getStoreApplicationJsonLDData())
                        }
                    }),
                    (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: data.description
                    })
                ]
            }),
            header ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader["default"], {
                themeType: data === null || data === void 0 ? void 0 : data.appliedCssClassNames,
                header: header,
                title: data.title,
                globalScripting: globalScript,
                data: data
            }) : null,
            data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid["default"], {
                eventHandler: eventHandler,
                isScrollMarginRequired: isScrollMarginRequired,
                data: data,
                count: 0,
                breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb["default"], {
                        data: data,
                        fullData: fullData
                    }),
                productAccordion: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion/* default */.Z, {
                        data: data,
                        fullData: fullData
                    }),
                contactUsFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(KnowledgeArticleFiller/* default */.Z, {}),
                contactUs: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUs/* default */.Z, {
                        data: data
                    }),
                leadGeneration: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LeadGeneration/* default */.Z, {
                        data: data
                    }),
                keySpecifier: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(KeySpecifier/* default */.Z, {
                        data: data
                    }),
                associateMembership: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(AssociateMembership/* default */.Z, {
                        data: data
                    }),
                friendsAndFamily: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FriendsAndFamily/* default */.Z, {
                        data: data
                    }),
                literature: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Literature/* default */.Z, {
                        data: data
                    }),
                technicalSpecifications: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "main-content",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalSpecs/* default */.Z, {
                            data: data
                        })
                    }),
                knowledgeArticle: (data, urlNames)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(KnowledgeArticle/* default */.Z, {
                        data: data,
                        urlNames: urlNames,
                        data404: data404
                    }),
                knowledgeArticleFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(KnowledgeArticleFiller/* default */.Z, {}),
                urlNames: urlNames,
                browseAllStores: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BrowseAllStores/* default */.Z, {
                        data: data
                    }),
                installDesignServices: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(InstallDesignServices/* default */.Z, {
                        data: data
                    }),
                findStore: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FindStore/* default */.Z, {
                        data: data
                    }),
                productList: (data, eventHandler)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ProductList, {
                        data: data,
                        eventHandler: eventHandler
                    }),
                productListFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PLPLoader/* default */.Z, {})
                    }),
                upSellContainer: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellInstallServices/* default */.Z, {
                        authData: data
                    })
            }) : null,
            footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter["default"], {
                footer: footer,
                footerScripting: footerScript
            }) : null,
            !isEmpty_default()(storeData) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDataTags, {
                authData: storeData
            }) : null
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var _page_ = (Page);


/***/ }),

/***/ 41256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productPromoBanner":"v1_productPromoBanner__ec8JR"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [361,2857,2247,4331,1286,3147,1054,1976,2710,7783,7710,772,5979,4751,6687,4543,8337,5266,5395,3415,448,498,9774,2888,179], function() { return __webpack_exec__(79477); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);